if (!customElements.get('raaw-product-tools')) {
  customElements.define('raaw-product-tools', class extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section');
      this.sync = this.sync.bind(this);
      this.updateVisibility = () => {
        const bar = this.querySelector('[data-raaw-sticky]');
        const nativeButton = this.section.querySelector('product-form button[name="add"]');
        if (!bar || !nativeButton) return;
        const visible = window.matchMedia('(max-width: 991px)').matches;
        if (bar.hidden === visible) bar.hidden = !visible;
        document.body.classList.toggle('raaw-purchase-active', visible);
      };
      this.onScroll = () => {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = null;
          this.updateVisibility();
        });
      };
      window.addEventListener('scroll', this.onScroll, {passive: true});
      window.addEventListener('resize', this.onScroll);
      this.visibilityObserver = new IntersectionObserver(this.updateVisibility);
      const nativeBuy = this.section.querySelector('product-form button[name="add"]');
      if (nativeBuy) this.visibilityObserver.observe(nativeBuy);
      this.onClick = event => {
        const trigger = event.target.closest('[data-raaw-buy]');
        if (!trigger) return;
        const button = this.section.querySelector('product-form button[name="add"]');
        if (button && !button.disabled) button.click();
      };
      this.addEventListener('click', this.onClick);
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.section, {subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-busy', 'value', 'class']});
      this.section.addEventListener('change', this.sync);
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.visibilityObserver?.disconnect();
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      cancelAnimationFrame(this.scrollFrame);
      document.body.classList.remove('raaw-purchase-active');
      this.removeEventListener('click', this.onClick);
      this.section?.removeEventListener('change', this.sync);
    }
    sync() {
      const service = this.section.querySelector('.raaw-service');
      if (service && !service.querySelector('[data-raaw-fit-near-buy]')) {
        const fitGuide = Array.from(document.querySelectorAll('.product-extra .raaw-technical details')).find(detail => {
          const title = detail.querySelector('summary')?.textContent.trim().toLowerCase() || '';
          return /^(pasform.*størrelse|størrelse.*pasform|fit.*size|size.*fit)/.test(title);
        });
        if (fitGuide) {
          fitGuide.dataset.raawFitNearBuy = '';
          service.append(fitGuide);
        }
      }
      for (const summary of document.querySelectorAll('.raaw-technical summary, .raaw-service summary')) {
        if (summary.querySelector('svg')) continue;
        const title = summary.textContent.trim().toLowerCase();
        let shapes = '<circle cx="12" cy="12" r="9"/><path d="M12 11v6m0-10v1"/>';
        if (/raaw explainer/.test(title)) shapes = '<path d="M9 18h6m-6 3h6m-6-6c0-2-3-3-3-7a6 6 0 0 1 12 0c0 4-3 5-3 7v1H9v-1Z"/>';
        else if (/material|fabric/.test(title)) shapes = '<path d="M4 4h16v16H4ZM8 4v16m4-16v16m4-16v16M4 8h16M4 12h16M4 16h16"/>';
        else if (/pasform|størrelse|fit|size/.test(title)) shapes = '<path d="m8 3-6 4 3 5 3-2v11h8V10l3 2 3-5-6-4c-1 3-7 3-8 0Z"/>';
        else if (/pleje|vask|care|wash/.test(title)) shapes = '<path d="M12 2s-7 8-7 13a7 7 0 0 0 14 0c0-5-7-13-7-13Z"/><path d="M8 15a4 4 0 0 0 4 4"/>';
        else if (/ingredien|nærings|nutrition|energy/.test(title)) shapes = '<path d="m14 2-9 12h6l-1 8 9-12h-6l1-8Z"/>';
        const icon = document.createElementNS('http://www.w3.org/2000/svg','svg');
        icon.setAttribute('viewBox','0 0 24 24');
        icon.setAttribute('aria-hidden','true');
        icon.setAttribute('focusable','false');
        icon.classList.add('raaw-detail-icon');
        icon.innerHTML = shapes;
        summary.prepend(icon);
      }
      const nativeButton = this.section.querySelector('product-form button[name="add"]');
      const nativeJson = this.section.querySelector('[data-variant-info="json"]');
      let variant;
      try { variant = JSON.parse(nativeJson?.textContent || 'null'); } catch { return; }
      const button = this.querySelector('[data-raaw-buy]');
      if (button && nativeButton) {
        const busy = nativeButton.getAttribute('aria-busy') === 'true' || nativeButton.classList.contains('loading');
        const disabled = nativeButton.disabled || busy;
        if (button.disabled !== disabled) button.disabled = disabled;
        const label = nativeButton.textContent.trim();
        if (button.textContent.trim() !== label) button.textContent = label;
      }
      const label = this.querySelector('[data-raaw-selection]');
      if (label && variant) {
        const title = variant.public_title || (variant.title === 'Default Title' ? '' : variant.title);
        const color = this.getAttribute('color') || '';
        const value = [color, title].filter(Boolean).join(' · ');
        if (label.textContent !== value) label.textContent = value;
      }
      const price = this.querySelector('[data-raaw-price]');
      const nativePrice = this.section.querySelector('[data-variant-info="price"]');
      if (price && nativePrice) {
        const content = nativePrice.querySelector('.price')?.cloneNode(true);
        if (content) {
          content.removeAttribute('id');
          content.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
          if (price.innerHTML !== content.outerHTML) price.innerHTML = content.outerHTML;
        }
      }
      this.updateVisibility();
      for (const swatch of this.section.querySelectorAll('[data-raaw-sibling]')) {
        let variants;
        try { variants = JSON.parse(swatch.getAttribute('data-raaw-variants')); } catch { continue; }
        const match = variants.find(item => item.title === variant?.title && item.available);
        const url = new URL(swatch.getAttribute('data-raaw-sibling'), window.location.origin);
        if (match) url.searchParams.set('variant', match.id);
        const next = url.pathname + url.search;
        if (swatch.getAttribute('href') !== next) swatch.setAttribute('href', next);
      }
    }
  });
}


(() => {
  let attempts = 0;
  const observedChatRoots = new WeakSet();
  function compactChat() {
    const host = document.querySelector('shopify-chat');
    const runtime = host?.shadowRoot?.querySelector('shopify-agent-runtime');
    const root = runtime ? runtime.shadowRoot : host?.shadowRoot;
    if (!root || !root.querySelector('[part="activator"]')) return false;
    if (!observedChatRoots.has(root)) {
      observedChatRoots.add(root);
      const refreshObserver = new MutationObserver(compactChat);
      refreshObserver.observe(root, {childList:true,subtree:true});
    }
    if (root.querySelector('[data-raaw-compact-chat]')) return true;
    const style = document.createElement('style');
    style.dataset.raawCompactChat = '';
    style.textContent = `.activator {width:52px!important;height:52px!important;min-width:52px!important;padding:14px!important;border-radius:50%!important;gap:0!important;box-sizing:border-box!important}.activator__label {display:none!important}.activator__icon {width:24px!important;height:24px!important}.activator-nudge {bottom:0!important;right:0!important;transform:none!important;will-change:auto!important;contain:none!important}`;
    root.append(style);
    const activator = root.querySelector('[part="activator"]');
    if (activator) {
      const observer = new MutationObserver(() => document.body.classList.toggle('raaw-chat-open', activator.getAttribute('aria-expanded') === 'true'));
      observer.observe(activator, {attributes:true,attributeFilter:['aria-expanded']});
    }
    return true;
  }
  if (!compactChat()) {
    const timer = setInterval(() => {
      attempts += 1;
      if (compactChat() || attempts >= 120) clearInterval(timer);
    }, 500);
  }
})();

